var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnidades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 175H175M33.3333 175V83.3333L54.1667 45.8333L100 25L145.833 45.8333L166.667 83.3333V175M75 175V133.333C75 131.123 75.878 129.004 77.4408 127.441C79.0036 125.878 81.1232 125 83.3333 125H116.667C118.877 125 120.996 125.878 122.559 127.441C124.122 129.004 125 131.123 125 133.333V175M83.3333 75C83.3333 79.4203 85.0893 83.6595 88.2149 86.7851C91.3405 89.9107 95.5797 91.6667 100 91.6667C104.42 91.6667 108.66 89.9107 111.785 86.7851C114.911 83.6595 116.667 79.4203 116.667 75C116.667 70.5797 114.911 66.3405 111.785 63.2149C108.66 60.0893 104.42 58.3333 100 58.3333C95.5797 58.3333 91.3405 60.0893 88.2149 63.2149C85.0893 66.3405 83.3333 70.5797 83.3333 75Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnidades);
export default __webpack_public_path__ + "static/media/Unidades.1b5fd5e8368ecf7f1259f9cfa650dace.svg";
export { ForwardRef as ReactComponent };